/* Sector kits — add an entire equipment package to the quote in one click.

   The quote app cannot bulk-add and exposes no JavaScript API (confirmed by
   Samita support, 25 Aug 2026), so packages go into the Shopify cart, which is
   the quote basket on this store. /cart/add.js takes an items array, so the
   whole package is a single request. */
(function () {
  'use strict';

  function fail(button, message) {
    var box = button.parentNode.querySelector('[data-sp-kit-error]');
    button.disabled = false;
    button.classList.remove('is-busy');
    button.textContent = button.dataset.spKitLabel || 'Add Package to Quote';
    if (box) {
      box.hidden = false;
      box.textContent = message;
    }
  }

  document.addEventListener('click', function (event) {
    var button = event.target.closest('[data-sp-kit]');
    if (!button) return;
    event.preventDefault();

    var box = button.parentNode.querySelector('[data-sp-kit-error]');
    if (box) box.hidden = true;

    var items;
    try {
      items = JSON.parse(button.dataset.spKitPayload || '[]');
    } catch (e) {
      // A malformed payload means a package was built with a broken product
      // reference. Say so — never drop the click silently.
      fail(button, 'This package could not be read. Please contact us and we will quote it directly.');
      return;
    }

    if (!items.length) {
      fail(button, 'This package has no items configured yet.');
      return;
    }

    if (!button.dataset.spKitLabel) button.dataset.spKitLabel = button.textContent.trim();
    button.disabled = true;
    button.classList.add('is-busy');
    button.textContent = 'Adding…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        if (!r.ok) {
          return r.json().catch(function () { return {}; }).then(function (body) {
            throw new Error(body.description || 'Could not add this package.');
          });
        }
        return r.json();
      })
      .then(function () {
        window.location = '/cart';
      })
      .catch(function (err) {
        fail(button, err.message + ' You can still add items individually.');
      });
  });
})();
